/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientSecretResponse
 */
export interface ClientSecretResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientSecretResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSecretResponse
     */
    keyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSecretResponse
     */
    secretText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSecretResponse
     */
    hint?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClientSecretResponse
     */
    startsOn?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ClientSecretResponse
     */
    endsOn?: Date | null;
}

/**
 * Check if a given object implements the ClientSecretResponse interface.
 */
export function instanceOfClientSecretResponse(value: object): value is ClientSecretResponse {
    return true;
}

export function ClientSecretResponseFromJSON(json: any): ClientSecretResponse {
    return ClientSecretResponseFromJSONTyped(json, false);
}

export function ClientSecretResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientSecretResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'keyId': json['keyId'] === undefined ? undefined : json['keyId'] === null ? null : json['keyId'],
        'secretText': json['secretText'] === undefined ? undefined : json['secretText'] === null ? null : json['secretText'],
        'hint': json['hint'] === undefined ? undefined : json['hint'] === null ? null : json['hint'],
        'startsOn': json['startsOn'] === undefined ? undefined : json['startsOn'] === null ? null : (new Date(json['startsOn'])),
        'endsOn': json['endsOn'] === undefined ? undefined : json['endsOn'] === null ? null : (new Date(json['endsOn'])),
    };
}

export function ClientSecretResponseToJSON(json: any): ClientSecretResponse {
    return ClientSecretResponseToJSONTyped(json, false);
}

export function ClientSecretResponseToJSONTyped(value?: ClientSecretResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'keyId': value['keyId'],
        'secretText': value['secretText'],
        'hint': value['hint'],
        'startsOn': value['startsOn'] == null ? value['startsOn'] : value['startsOn'].toISOString(),
        'endsOn': value['endsOn'] == null ? value['endsOn'] : value['endsOn'].toISOString(),
    };
}

